import ReactDOM from "react-dom/client";
import { createBrowserRouter, createRoutesFromElements, RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { appRoutes } from "./App";
import { AllCommunityModule, ModuleRegistry, ValidationModule } from "ag-grid-community";
import { queryClient } from "src/utils/queryClient";

ModuleRegistry.registerModules([AllCommunityModule, ValidationModule]);

const router = createBrowserRouter(createRoutesFromElements(appRoutes));

const app = document.getElementById("root");

if (app) {
  const root = ReactDOM.createRoot(app);

  root.render(
    <>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </>,
  );
}
